import { FC } from 'react';

import { Chips } from '@core/ui';
import { useSession } from '@core/auth';
import { useTranslation } from '@wearehelpful/ui-localization';

import { useBenefits } from '../../../../../../providers/BenefitsProvider';

import { Tags } from './PlansTags.style';

export const PlansTags: FC = () => {
  const { t } = useTranslation();
  const [{ isSessionExist }] = useSession();
  const [{ meta }] = useBenefits();

  return (
    <Tags>
      {!isSessionExist && (
        <Chips.Item status="error">
          {t('forms.noInsurancePlanConnected')}
        </Chips.Item>
      )}
      {meta && <Chips.Item status="success">{meta.title}</Chips.Item>}
    </Tags>
  );
};
